/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { useGlobalContext } from '../../../../context/ContextGlobal'
import { DateTimeNow } from '../../../../utils/dates'
import { NewUser } from '../../../../utils/requests'
import { TryCatch } from '../../../../utils/general'
import {
  deleteDocumentField,
  deleteSubDocument,
  getDocument,
  getSubDocument,
  getSubDocuments,
  setSubDocument,
} from '../../../../firebase/firestore'

export const useClientAddUsers = () => {
  const { user, formContext, setFormContext, dataContext, setDataContext, setAlerts, loading, setLoading } =
    useGlobalContext()
  const [search, setSearch] = useState('')
  const { id: clientId } = useParams()

  const getData = async () => {
    const getUsers = await getSubDocuments('clientes', clientId, 'users')

    setDataContext({ usersClient: getUsers })
  }

  const addUser = async () => {
    // if (!user?.user?.permissions?.users_add) {
    //   return setAlerts((prev) => [
    //     ...prev,
    //     {
    //       type: 'error',
    //       title: 'Permissão Negada',
    //       msg: 'Você não possui permissão para adicionar usuarios',
    //     },
    //   ])
    // }

    // if (user?.client?.responsavel?.email === formContext?.email) {
    //   return setAlerts((prev) => [
    //     ...prev,
    //     {
    //       type: 'error',
    //       title: 'Usuário Administrador',
    //       msg: 'Você não pode adicionar outro usuário com o mesmo email do administrador.',
    //     },
    //   ])
    // }

    let permissionsAdmins
    let SectorId
    try {
      permissionsAdmins = await getSubDocument('clientes', clientId, 'sectors', 'admin')
      SectorId = permissionsAdmins?.id
    } catch (error) {}

    if (!SectorId) {
      const clientsPermissions = await getDocument('configs', 'clients_permissions')

      const permissions = Object.keys(clientsPermissions)
        .filter((permission) => permission !== 'id')
        .reduce((acc, permission) => {
          Object.keys(clientsPermissions?.[permission] || {}).forEach((key) => {
            acc[`${permission}_${key}`] = clientsPermissions[permission][key]
          })
          return acc
        }, {})

      permissionsAdmins = {
        nome: 'Admin',
        description: 'Permissões padrões de Administrador',
        permissions,
      }

      SectorId = await setSubDocument('clientes', clientId, 'sectors', 'admin', permissionsAdmins)
    }

    const newUserData = {
      nome: formContext?.user_name,
      cargo: formContext?.user_role,
      email: formContext?.user_email,
      cpf: formContext?.user_cpf,
      photoUrl: '',
      sectorId: 'admin',
      createBy: user.user.nome,
      dtCreated: DateTimeNow(),
      status: true,
      type: 'client',
    }

    await NewUser(newUserData, clientId, setAlerts, formContext.user_password, false)
    await setFormContext({ openModal: false })
    FetchGetData()
  }

  const editUser = async (id) => {
    const getUserInfo = dataContext?.usersClient.find((user) => (user.id === id ? user : ''))

    setFormContext((prev) => ({
      ...prev,
      openModal: prev?.openModal ? !prev?.openModal : true,
      user_name: getUserInfo.nome,
      user_role: getUserInfo.cargo,
      user_cpf: getUserInfo.cpf,
      user_email: getUserInfo.email,
    }))
  }

  const deleteUser = async (id) => {
    // deleta os dados salvos do usuário no subdocument users de clientes
    await deleteSubDocument('clientes', clientId, 'users', id)

    // deleta o id do campo "users" do cliente
    await deleteDocumentField('clientes', clientId, `users.${id}`)

    await setFormContext({ openModal: false })
    FetchGetData()
  }

  const HandleAddUser = async () => {
    await TryCatch(addUser, setLoading, setAlerts)
  }

  const HandleEditUser = async (id) => {
    await TryCatch(
      async () => {
        await editUser(id)
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleDeleteUser = async (id) => {
    await TryCatch(
      async () => {
        await deleteUser(id)
      },
      setLoading,
      setAlerts,
    )
  }

  const FetchGetData = async () => {
    await TryCatch(getData, setLoading, setAlerts)
  }

  useEffect(() => {
    FetchGetData()
  }, [])

  return {
    setFormContext,
    formContext,
    search,
    setSearch,
    dataContext,
    loading,
    FetchGetData,
    HandleAddUser,
    HandleEditUser,
    HandleDeleteUser,
  }
}
